export default {
  "foot": {
    "title": "Joueurs Century Games",
    "p1": "Saisissez votre ID utilisateur, payez pour les recharges. Le montant sera mis à jour sur votre compte associé directement. S'il ne s'affiche pas relancez le jeu, ou contactez le support si besoin.",
    "p2": "Si vous avez des questions, n'hésitez pas à contacter le service client. Merci de votre soutien !",
    "copyright": "© Copyright 2024 Century Games.",
    "service": "Conditions d'utilisation",
    "policy": "Politique de Confidentialité",
    "descriptionTitle": "Comment ça marche ?"
  },
  "accept": {
    "title": "Ce site web utilise des cookies pour améliorer votre expérience de naviguation. Merci de lire notre <a href=\"https://www.centurygames.com/privacy-policy/\" style=\"color: #58a8a5;\">Politique de Confidentialité</a>  pour plus d'inforations sur ce que nous collectons sur notre site web. En continuant à utiliser ce site, vous acceptez que nous stocker et accéder aux cookies sur votre appareil.",
    "decline": "Refuser",
    "accept": "Accepter"
  },
  "game": {
    "inapptext": "Ou se connecter via le Jeu",
    "loginfail": "Échec de la connexion",
    "logintip": "Si l'autorisation échoue dans le jeu, merci de m'être à jour le jeu avec la dernière version ou d'essayer avec un autre navigateur.",
    "reloadmsg": "Merci d'appuyer sur le bouton \"Recharger\" pour avoir le résultat de la connexion.",
    "reload": "Recharger",
    "appnotice": "Si vous souhaitez vous connecter via l'app du jeu, merci d'utiliser un navigateur externe pour ouvrir la boutique.",
    "changeaccount": "Êtes-vous sûr de vouloir vous déconnecter de votre compte ?",
    "login": "Se connecter",
    "notice": "Notification",
    "confirm": "Confirmer",
    "loginuserid": "ID Utilisateur",
    "palceholder": "Saisissez ID Utilisateur",
    "okbtn": "OK",
    "loginbtn": "Se connecter via le jeu",
    "changebtn": "Ou se connecter avec ID Utilisateur",
    "useTitle": "COMPTE",
    "checkBtn": "Vérifier",
    "findid": "Vous ne trouvez pas votre ID ?",
    "checktext": "Se trouve normalement dans les paramètres, appuyez sur le point d'interrogation pour plus de conseils.",
    "username": "Pseudo :",
    "userId": "ID Utilisateur :",
    "packageTitle": "Montant de la recharge",
    "edit": "Modifier",
    "paymentTitle": "MÉTHODE DE PAIEMENT",
    "total": "Total",
    "goPay": "Payer maintenant",
    "noSelectPackageTips": "Vous n'avez pas sélectionné de montant",
    "payFail": "ÉCHEC DU PAIEMENT",
    "camelPayfail": "Échec du paiement",
    "payFailTips1": "Merci de contacter le service client Adyen",
    "payFailTips2": "Merci de contacter le service client PayPal",
    "paySuccess": "PAIMENT RÉUSSI",
    "paySuccessTips2": "Merci de relancer le jeu d'abord avant de contacter le service client si vous n'avez pas reçu votre achat !",
    "camelPaySuccess": "Paiement réussi",
    "transactionId": "ID Transaction",
    "paySuccessTips": "La livraison des objets peut prendre un moment",
    "deliveryFail": "ÉCHEC DE LA LIVRAISON",
    "deliveryFailTips": "Merci de contacter le service client",
    "orderTitle": "Résumé de votre commande",
    "paidWith": "Méthode de paiement",
    "orderID": "ID Transaction",
    "payStatus": "Statut du paiement",
    "orderTotal": "Prix total",
    "transactionDate": "Date de la transaction",
    "goOnPay": "Acheter à nouveau",
    "getInvoice": "Facture",
    "camelDeliveryFail": "Échec de la livraison",
    "confirmOrder": "CONFIRMATION DE COMMANDE",
    "confirmFollow": "Confirmez ce qui suit :",
    "nickname": "Pseudo",
    "packageName": "Objets",
    "totalPayment": "Prix total",
    "confirmPayWith": "Méthode de paiement",
    "confirmAndGoOn": "Confirmer et procéder au paiement",
    "orderCancel": "Annuler",
    "getInvoiceTitle": "Envoyer par email",
    "getInvoiceTips": "Si vous souhaitez recevoir une facture par mail, merci de saisir une adresse email.",
    "getInvoiceTips1": "Saisissez votre adresse email pour recevoir la facture",
    "getInvoiceTips2": "Accepter la collecte et le stockage de votre adresse email.",
    "getInvoiceTips3": "Accepter de recevoir des emails de réductions, de promotions et plus encore sur nos jeux via email.",
    "invoiceSend": "Envoyer",
    "sendSuccess": "Facture envoyée par email",
    "id404": "ID utilisateur introuvable",
    "packageLoadingText": "Mise à jour de la boutique d'objets...",
    "taxTips": "Prix toutes taxes comprises",
    "adyenTips": "Ce service de paiement est fourni par Adyen, qui exerce sous licence bancaire et supervision de la Banque Centrale des pays-Bas. Si vous avez des questions sur ses certifications, merci de vous référer à <a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a>. Pour savoir comment vos données sont protégées, merci de vous référer à <a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and-disclaimer/privacy-policy</a>.",
    "paypalTips": "Ce service de paiement est fourni par PayPal. Pour savoir comment vos données sont protégées, merci de vous référer à <a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2/webapps/mpp/ua/privacy-full</a>",
    "switchCountryTips": "Votre pays/région favri est ${servercountry}. Souhaitez-vous changer de pays et de monnaie ?",
    "paypalBtn": "Payer maintenant par carte",
    "paypalOr": "Ou",
    "paypalCard1": "Nom du titulaire de la carte (optionnel)",
    "paypalCard2": "Numéro de carte",
    "checkUserID": "Lien",
    "success": "SUCCÈS",
    "changeCurrencyContent": "Souhaitez-vous changer de région et de monnaie pour les adapter à votre paramètre de jeu actuel : ${servercountry} ？",
    "productDescription": "Les Billets de Ferme sont l'équivalent du cash qui permet d'acheter n'importe quel pack ou offre dans le jeu.",
    "payButton": "PAYER",
    "userIdNotice": "Merci de saisir votre ID Utilisateur pour lier votre compte jeu d'abord",
    "account": "Compte",
    "card": "Carte",
    "notification": "Entrez votre ID Utilisateur pour lier votre compte, sélectionnez les objets souhaités ensuite payez avec votre moyen de paiement préféré. Une fois le jeu relancé, les objets achetés seront sur votre compte, disponibles à l'utilisation.\n\nSi vous avez des questions, n'hésitez pas à contacter notre service client dans le jeu.",
    "rongluRank": "Niveau de Chaudière :",
    "tips": "Comment l'utiliser ?",
    "checkTIps1": "J'ai lu et j'accepte la <a :href=\"policyUrl\">« Politique de confidentialité »</a>, <a :href=\"serviceURl\"> les « Conditions générales d'utilisation »</a> et les <a :href=\"paymentURl\">« Modalités de paiement »</a>.",
    "checkTIps2": "Veuillez lire et cocher la case",
    "selectTips": "(La devise du dernier achat dans le jeu sera sélectionnée)",
    "koPayTips": "*Si votre carte bancaire utilise le Won Coréen comme devise étrangère, le service de Conversion Dynamique de Change (DCC) sera utilisé et des frais supplémentaires peuvent être facturés par un proxy tiers et non par ce site web.",
    "PayTips": ""
  },
  "invoice": {
    "title": "Facture",
    "transactionId": "ID Transaction",
    "transactionDate": "Date de la transaction",
    "totalAmount": "Montant total",
    "paymentMethod": "Méthode de paiement",
    "description": "Description",
    "game": "Jeu",
    "quantity": "Quantité",
    "price": "Prix",
    "amount": "Montant",
    "total": "Montant total",
    "footTitle": "Notes",
    "footContent": "Merci de votre soutien à Century Games !",
    "button1": "Obtenir la Facture",
    "button2": "Retour sans facture",
    "giveupInvoice": "Vous ne recevrez pas de reçu pour cette commande. Souhaitez-vous confirmer ?"
  },
  "payment": {
    "card": "Carte de crédit/Carte de débit",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "PAYS/RÉGION",
    "Africa": "Afrique",
    "America": "Amérique",
    "Asia": "Asie",
    "Europe": "Europe",
    "Oceania": "Océanie",
    "ZA": "Afrique du Sud",
    "US": "États-Unis",
    "HK": "Hong Kong, Chine",
    "JP": "Japon",
    "KR": "Corée",
    "SG": "Singapour",
    "SA": "Arabie Saoudite",
    "IQ": "Irak",
    "TW": "Taïwan, Chine",
    "TH": "Thaïlande",
    "GB": "Royaume-Uni",
    "AU": "Australie",
    "countryLanguage1": "LANGUE",
    "AE": "Émirats Arabes Unis",
    "DE": "Allemagne",
    "PT": "Portugal",
    "RU": "Russie",
    "ES": "Espagne",
    "CH": "Suisse",
    "TR": "Turquie",
    "KW": "Koweït",
    "QA": "Qatar",
    "PL": "Pologne",
    "ID": "Indonésie",
    "IT": "Italie",
    "IN": "Inde",
    "FR": "France",
    "CA": "Canada",
    "NL": "Pays-Bas",
    "AT": "Autriche",
    "RS": "Serbie",
    "SE": "Suède",
    "MY": "Malaisie",
    "BE": "Belgique",
    "DK": "Danemark",
    "FI": "Finlande",
    "PH": "Philippines",
    "NO": "Norvège",
    "BR": "Brésil",
    "NZ": "Nouvelle-Zélande",
    "UA": "Ukraine",
    "RO": "Roumanie"
  },
  "extra_info": {
    "kingdom": "Région : #"
  },
  "adyen": {
    "note": "Le service de paiement est fourni par Adyen, offrants des transactions sécurisées avec le plus haut niveau de certification PCI-DSS des organisations de carte de crédit permettant des paiements par carte domestique et étrangère.",
    "note2": "Note : cochez « enregistrer mes informations de paiement » pour sauvegarder votre carte de paiement actuel dans votre navigateur en vue de paiements ultérieurs."
  },
  "pay": {
    "error1": "Si quelque chose ne fonctionne pas, merci d'essayer à nouveau plus tard ou d'utiliser un autre moyen de paiement. N'hésite pas à contacter le service client si tu as plus de questions."
  },
  "meta": {
    "title": "Boutique Family Farm Adventure",
    "description": "La Boutique Family Farm Adventure est la Boutique officielle du jeu, offrant des moyens de recharger à prix réduit et des packs de jeu pour les joueurs.",
    "keywords": "Ferme, cultures, marché, améliorations, exploration, carte, personnage, niveau, simulation, stratégie, payer, boutique, recharge, paiement"
  }
};


// WEBPACK FOOTER //
// ./src/lang/FR.js